export default __webpack_public_path__ + "static/media/stream-link.a36205dd.png";